export default __webpack_public_path__ + "static/card3-0e3cdff1e593432c4c71e8aaa94350ce.png";